import { Component } from 'react'
import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import OSMSatellite from '../../../utils/mapUtils/layers/OSMSatellite'
import SiteTypes from '../../../utils/mapUtils/SiteTypes'
import SingleStationPoint from '../../../utils/mapUtils/layers/SingleStationPoint'
import Map from '../../../utils/mapUtils/Map'
import DtoPoint from '../../dto/DtoPoint'

class PointMap extends Component {
	constructor(props) {
		super(props)
	}

	getData = () => {
		if (this.props.point.xCoordinate && this.props.point.yCoordinate) {
			const layersGroup1 = [
				OSMSatellite(),
				SingleStationPoint({
					site: this.props.point,
					type: SiteTypes[this.props.point.typeParameter]
				})
			]
			const mapConf = {
				size: this.props.height,
				center: [this.props.point.xCoordinate, this.props.point.yCoordinate],
				zoom: 18
			}
			return [mapConf, layersGroup1]
		}
		return ['', '']
	}

	render() {
		if (this.props.point) {
			const data = this.getData()
			return (
				<div className={ 'row map-point-panel no-margin' }>
					<div className='col s12 no-padding'>
						<Map mapConf={ data[0] } layers={ data[1] }/>
					</div>
				</div>
			)
		}
		return null
	}
}

PointMap.propTypes = {
	point: PropTypes.objectOf(DtoPoint),
	height: PropTypes.number
}

PointMap.defaultProps = {
	height: 100
}
const mapStateToProps = store => {
	return {
		point: store.PointReducer.point
	}
}

export default connect(mapStateToProps)(PointMap)



// WEBPACK FOOTER //
// ./src/point/components/map/PointMap.js